import React from "react";
import { Accordion, Button, ButtonGroup, Col, FormControl, FormGroup, FormLabel, InputGroup, Row } from "react-bootstrap";
import { DesignerElement } from "../../helpers";
import { DesignerFont } from "./DesignerFont";
import { ImageEditor } from "../";
import Slider from "rc-slider";
import 'rc-slider/assets/index.css';
import { DesignerAnimations } from "./DesignerAnimations";


interface Props {
  selectedElement?: DesignerElement,
  selectedIndex?: number,
  updateValue: (el: DesignerElement) => void,
  updateIndex: (newIndex: number) => void,
  remove: () => void
  duplicate: () => void
}

export const DesignerSidebar: React.FC<Props> = props => {
  const [showFont, setShowFont] = React.useState(false);
  const [showImageEditor, setShowImageEditor] = React.useState(false);





  const handleChange = (e: any) => {
    updateValue(e.currentTarget.id, e.currentTarget.value)
  }

  const toggleValue = (id: string) => {
    let el: DesignerElement = { ...props.selectedElement };
    switch (id) {
      case "bold": el.bold = !el.bold; break;
      case "italic": el.italic = !el.italic; break;
      case "underline": el.underline = !el.underline; break;
      case "textShadow": el.textShadow = !el.textShadow; break;
    }
    props.updateValue(el);
  }

  const updateValue = (id: string, val: string) => {
    let el: DesignerElement = { ...props.selectedElement };
    switch (id) {
      case "opacity": el.opacity = parseFloat(val); break;
      case "size": el.size = parseFloat(val); break;
      case "lineHeight": el.lineHeight = parseFloat(val); break;
      case "url": el.url = val; break;
      case "text": el.text = val; break;
      case "color": el.color = val; break;
      case "font": el.font = val; break;
      case "lockAspectRatio": el.lockAspectRatio = val === "true"; break;
      case "borderType":
        if (!el.border) el.border = { type: "solid", color: "#000000", width: 1 };
        if (!el.border.color) el.border.color = "#000000";
        if (!el.border.width) el.border.width = 1;
        el.border.type = val;
        break;
      case "borderColor":
        if (!el.border) el.border = { type: "solid", color: "#000000", width: 1 };
        el.border.color = val;
        break;
      case "borderWidth":
        if (!el.border) el.border = { type: "solid", color: "#000000", width: 1 };
        el.border.width = parseFloat(val);
        break;
      case "align":
        switch (val) {
          case "left": el.align = "left"; break;
          case "right": el.align = "right"; break;
          case "center": el.align = "center"; break;
        }
        break;
    }
    props.updateValue(el);
  }

  const getProperties = () => {
    if (props.selectedElement) {
      return (<>
        <Accordion defaultActiveKey="typeOptions" >
          {getTypeOptions()}
          {getLayerOptions()}
          <DesignerAnimations selectedElement={props.selectedElement} updateValue={props.updateValue} />
        </Accordion>
        <Row>
          <Col className="d-grid">
            <Button variant="danger" className="w-100" style={{ marginTop: 20 }} onClick={e => { e.preventDefault(); props.remove() }}>Remove Item</Button>
          </Col>
          <Col className="d-grid">
            <Button variant="success" className="w-100" style={{ marginTop: 20 }} onClick={e => { e.preventDefault(); props.duplicate() }}>Duplicate Item</Button>
          </Col>
        </Row>

      </>);
    }
  }


  const getBoxOptions = () => {
    let el = props.selectedElement
    return (<>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Color</FormLabel>
        <Col sm={8}><FormControl id="color" type="color" value={el.color || "#000099"} onChange={handleChange} size="sm" /></Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Opacity</FormLabel>
        <Col sm={8}>
          <Slider value={props.selectedElement?.opacity || 100} min={1} max={100} step={1} onChange={(val) => { updateValue("opacity", val.toString()) }} />
        </Col>
      </FormGroup>
      <h4>Border</h4>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Style</FormLabel>
        <Col sm={8}>
          <FormControl id="borderType" as="select" value={props.selectedElement?.border?.type || ""} onChange={handleChange} size="sm" >
            <option value="">None</option>
            <option value="solid">Solid</option>
            <option value="dotted">Dotted</option>
            <option value="dashed">Dashed</option>
          </FormControl>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Color</FormLabel>
        <Col sm={8}><FormControl id="borderColor" type="color" value={el.border?.color || "#000000"} onChange={handleChange} size="sm" /></Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Width</FormLabel>
        <Col sm={8}>
          <Slider value={props.selectedElement?.border?.width || 1} min={0.1} max={3} step={0.1} onChange={(val) => { updateValue("borderWidth", val.toString()) }} />
        </Col>
      </FormGroup>
    </>);
  }

  const getTextOptions = () => {
    let el = props.selectedElement
    return (<>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Font</FormLabel>
        <Col sm={8} className="d-grid">
          <Button variant="secondary" size="sm" className="w-100" onClick={(e) => { e.preventDefault(); setShowFont(true); }} >{el.font || "Roboto"}</Button>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Size</FormLabel>
        <Col sm={8}>
          <Slider value={props.selectedElement?.size || 9} min={1} max={50} step={0.1} onChange={(val) => { updateValue("size", val.toString()) }} />
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Line Height</FormLabel>
        <Col sm={8}>
          <Slider value={props.selectedElement?.lineHeight || 1.5} min={0.5} max={2.5} step={0.1} onChange={(val) => { updateValue("lineHeight", val.toString()) }} />
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Align</FormLabel>
        <Col sm={8}>
          <ButtonGroup>
            <Button variant={(el.align === "left" || !el.align) ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); updateValue("align", "left") }}><i className="fas fa-align-left"></i></Button>
            <Button variant={(el.align === "center") ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); updateValue("align", "center") }}><i className="fas fa-align-center"></i></Button>
            <Button variant={(el.align === "right") ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); updateValue("align", "right") }}><i className="fas fa-align-right"></i></Button>
          </ButtonGroup>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Style</FormLabel>
        <Col sm={8}>
          <ButtonGroup>
            <Button variant={(el.bold) ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); toggleValue("bold") }}><i className="fas fa-bold"></i></Button>
            <Button variant={(el.italic) ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); toggleValue("italic") }} aria-label="Italic" aria-pressed={el.italic}><i className="fas fa-italic" aria-hidden="true"></i></Button>
            <Button variant={(el.underline) ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); toggleValue("underline") }} aria-label="Underline" aria-pressed={el.underline}><i className="fas fa-underline" aria-hidden="true"></i></Button>
            <Button variant={(el.textShadow) ? "secondary" : "light"} size="sm" onClick={(e) => { e.preventDefault(); toggleValue("textShadow") }} aria-label="Text shadow" aria-pressed={el.textShadow}><i className="fas fa-clone" aria-hidden="true"></i></Button>
          </ButtonGroup>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Color</FormLabel>
        <Col sm={8}><FormControl id="color" type="color" value={el.color || "#FFFFFF"} onChange={handleChange} size="sm" /></Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Content</FormLabel>
        <Col sm={8}><FormControl as="textarea" id="text" value={props.selectedElement?.text || ""} onChange={handleChange} size="sm" rows={3} /></Col>
      </FormGroup>

    </>);
  }


  const handleImageUpdate = (dataUrl: string) => {
    if (dataUrl) {
      updateValue("url", dataUrl);
      setShowImageEditor(false);
    }
  }

  const getImageEditor = () => {

    /*
    <ButtonGroup>
            <Button variant={(aspectRatio === 16 / 9) ? "secondary" : "light"} onClick={(e) => { e.preventDefault(); setAspectRatio(16 / 9) }}>16:9</Button>
            <Button variant={(aspectRatio === 9 / 19) ? "secondary" : "light"} onClick={(e) => { e.preventDefault(); setAspectRatio(9 / 16) }}>9:16</Button>
            <Button variant={(aspectRatio === 4 / 3) ? "secondary" : "light"} onClick={(e) => { e.preventDefault(); setAspectRatio(4 / 3) }}>4:3</Button>
            <Button variant={(aspectRatio === 1) ? "secondary" : "light"} onClick={(e) => { e.preventDefault(); setAspectRatio(1) }}>1:1</Button>
            <Button variant={(aspectRatio === 0) ? "secondary" : "light"} onClick={(e) => { e.preventDefault(); setAspectRatio(0) }}>Free</Button>
          </ButtonGroup>*/
    if (showImageEditor) {
      return (
        <>

          <ImageEditor startingUrl={props.selectedElement.url} updatedFunction={handleImageUpdate} name="imageEditor" aspectRatio={0} height={200} />
        </>
      )
    }
  }

  const getImageOptions = () => {
    return (<>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Lock Aspect</FormLabel>
        <Col sm={8}>
          <FormControl id="lockAspectRatio" as="select" value={props.selectedElement?.lockAspectRatio?.toString() || "false"} onChange={handleChange} size="sm" >
            <option value="false">No</option>
            <option value="true">Yes</option>
          </FormControl>
        </Col>
      </FormGroup>
      <FormGroup as={Row} className="mb-3">
        <FormLabel column sm={4}>Image</FormLabel>
        <Col sm={8} className="d-grid">
          <Button variant="primary" size="sm" className="w-100" onClick={(e) => { e.preventDefault(); setShowImageEditor(true); }} >Select Image</Button>
        </Col>
      </FormGroup>
      {getImageEditor()}
    </>);
  }

  const getTypeOptions = () => {
    let contents = <></>
    let label = "";
    switch (props.selectedElement.type) {
      case "text":
        label = "Text Options";
        contents = getTextOptions();
        break;
      case "image":
        label = "Image Options";
        contents = getImageOptions();
        break;
      case "box":
        label = "Box Options";
        contents = getBoxOptions();
        break;
    }
    return <Accordion.Item eventKey="typeOptions">
      <Accordion.Header>{label}</Accordion.Header>
      <Accordion.Body>
        {contents}
      </Accordion.Body>
    </Accordion.Item>
  }


  const getLayerOptions = () => {
    return (
      <Accordion.Item eventKey="layer">
        <Accordion.Header>Layer</Accordion.Header>
        <Accordion.Body>
          <FormGroup as={Row} className="mb-3">
            <FormLabel column sm={3}>Order</FormLabel>
            <Col sm={9}>
              <InputGroup>
                <Button variant="primary" size="sm" onClick={(e) => { e.preventDefault(); props.updateIndex(props.selectedIndex - 1); }} aria-label="Move layer back">Back</Button>
                <FormControl id="layerOrder" disabled={true} value={props.selectedIndex} size="sm" />
                <Button variant="primary" size="sm" onClick={(e) => { e.preventDefault(); props.updateIndex(props.selectedIndex + 1); }} aria-label="Move layer front">Front</Button>
              </InputGroup>

            </Col>
          </FormGroup>
        </Accordion.Body>
      </Accordion.Item>);
  }

  const getFont = () => {
    if (showFont) return <DesignerFont onClose={() => { setShowFont(false) }} updateValue={(val) => { setShowFont(false); updateValue("font", val) }} />
  }


  return (
    <>
      {getFont()}
      <div id="designerSidebar">
        {getProperties()}

      </div>
    </>
  );

}